export const getPromoProducts = (page?: number, noLoading?: boolean) => ({
  type: "@saga/GET_PROMO_PRODUCTS",
  payload: { page, noLoading },
});
